import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { IAppState } from '../../core/redux/IAppState';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../../core/redux/api/module';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import { ACTION_TYPE } from '../../core/redux/actionType';
import { apiGuestComments } from '../../core/redux/api/endpoints';
import { GuestComment } from './guestComment';
import { updateGuest } from '../module';
import { assoc } from '../../language/module';


const KEY_ACTION = ACTION_TYPE.GET_HAS_COMMENTS_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.GET_HAS_COMMENTS_REQUEST,
  ACTION_TYPE.GET_HAS_COMMENTS_RESPONSE,
  ACTION_TYPE.GET_HAS_COMMENTS_ERROR,
];


/**
 * Makes an action that can be dispatched to get a specific guest's history of the comments guest agents have left on
 * them.
 */
export const getHasCommentsAction = (guestId: string) => makeApiAction(
  {
    method:   'GET',
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: apiGuestComments(guestId),
    types:    ACTIONS.map(action => ({ type: action, meta: { guestId } })) as RsaaTypes,
    bailout:  (state: IAppState) => !!getLoading(state, guestId, KEY_ACTION) || hasTrippedBreaker(state, KEY_ACTION),
  },
);


const reducer: ApiReducer<GuestComment[]> = (state, action, error, isLoading, payload) => {
  const guestId = action.meta.guestId;

  if (isLoading) {
    return addLoading(state, guestId, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, guestId, KEY_ACTION, error);
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, guestId, KEY_ACTION);

  return updateGuest(noLoadingOrError, guestId, guest => assoc('hasComments', (payload || []).length > 0, guest))
};


export const getHasCommentsReducer = makeApiReducer<GuestComment[]>(ACTIONS, KEY_ACTION, reducer);
